module.exports = __webpack_public_path__ + "static/media/1-xs.eebad97f.jpg";